<template>
  <div>
    <div class="title-banner">
      <div
        class="title-bar"
        :class="{ mobileStyle: isMinMobile }"
      >
        <img
          class="logoImg"
          :src="logoSrc"
          alt="primihub"
          @click="goHome"
        >
        <!-- 添加折叠面板 -->
        <template v-if="isMinMobile">
          <div
            ref="btnBox"
            class="btnBox"
            @click="addClass"
          />
          <el-drawer
            title="菜单"
            :visible.sync="drawer"
            :direction="direction"
            :with-header="false"
            size="50%"
            :before-close="closeDrawer"
          >
            <menu-list
              ref="menuDom"
              mode="vertical"
              @emitClick="handleClick"
            />
          </el-drawer>
        </template>
        <template v-else>
          <menu-list ref="menuDom" />
          <div class="flex git-box">
            <a
              href="https://github.com/primihub/primihub"
              target="_blank"
            >
              <img
                class="icon"
                src="../../assets/images/github.png"
                alt="github logo"
                height="32"
              >
            </a>
            <button
              class="free-button"
              @click="handleFreeClick('1')"
            >
              免费试用
            </button>
            <button
              class="free-button"
              @click="handleFreeClick('2')"
            >
              官方文档
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
	import menuList from './menu.vue';
	import { mobileMixins } from '@/mixins/mobile';
	export default {
		components: {
			menuList,
		},
		mixins:[mobileMixins],
		data() {
			return {
				logoSrc: require('@/assets/images/yuanyukeji.png'),
				drawer: false,
				direction: 'ttb',
			};
		},
		watch:{
			'isMinMobile'(val){
				if(val){
						this.$nextTick(()=>{
								this.initBtnBox()
						})
				}
			}
		},
		mounted() {
			this.initBtnBox();
		},
		methods: {
			goHome() {
				if(this.isMinMobile){
					this.$router.push({ path: '/' });
				}else{
					this.handleSelect('0');
				}
			},
			handleClick() {
				this.drawer = false;
				this.addClass();
			},
			handleSelect(index, typeName) {
				this.$refs.menuDom.handleSelect(index,typeName);
			},
			handleFreeClick(str) {
				if(str === '1'){
					this.$router.push({ path: '/apply' });
					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					});
				}else{
					window.open('https://docs.primihub.com/','_blank')
				}
			},
			setmenuActions(id, name) {
				this.handleSelect(id, name);
			},
			initBtnBox() {
				const btn = document.querySelector('.btnBox');
				Array(3)
					.fill(null)
					.forEach(() => {
						btn?.insertAdjacentHTML('beforeend', '<div></div>');
					});
			},
			addClass() {
				const btnBox = this.$refs.btnBox;
				const btnClassList = btnBox.classList;
				if (btnClassList.value.indexOf('btnBoxhover') > -1) {
					this.drawer = false;
					btnBox.classList.remove('btnBoxhover');
				} else {
					this.drawer = true;
					btnBox.classList.add('btnBoxhover');
				}
			},
			closeDrawer(down){
				this.addClass();
				down();
			}
		},
	};
</script>
<style scoped lang="scss">
	$width: 1200px;
	$baseColor: #1390ff;
	.title-banner {
		width: 100%;
		position: relative;
		.mobileStyle {
			display: flex;
			justify-content: space-between;
			padding: 0 10px;
			// background-color: #fff !important;
			.mobileIcon {
				font-size: 24px;
				color: black;
			}
			::v-deep .el-drawer__wrapper {
				top: 72px !important;
			}
		}
		.title-bar {
			max-width: $width;
			width: 100%;
			position: absolute;
			z-index: 2;
			top: 0px;
			left: 0px;
			right: 0px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			height: 74px;

			.logoImg {
				width: 144px;
				height: 36px;
			}
			.nav-bar-box {
				margin-left: 100px;
			}
		}
		.git-box {
			position: absolute;
			right: 0px;
			z-index: 2;
			.icon-github {
				font-size: 36px;
				color: #fff;
			}
			.free-button {
				cursor: pointer;
				color: #fff;
				background-color: #51565f;
				border: none;
				border-radius: 40px;
				margin-left: 20px;
                font-size: 14px;
                padding: 6px 12px;
			}
		}
		.flex {
			flex-direction: row;
			align-items: center;
		}
	}

	.el-menu.el-menu--horizontal {
		border: none;
	}

	::v-deep .el-menu {
		background: transparent;
		.el-menu-item {
			padding: 0px;
			background: transparent;
			font-size: 16px;
		}
		.is-active {
			background: transparent !important;
		}
		.el-submenu__title {
			font-size: 16px;
			height: 40px;
			line-height: 40px;
		}
		.el-submenu__title {
			padding: 0px;
			margin: 0 20px;
		}
	}

	::v-deep.el-menu--horizontal > .el-menu-item {
		height: 40px;
		line-height: 40px;
		margin: 0 20px;
	}

	::v-deep.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
	::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
		background: transparent;
		color: #1390ff;
	}
	::v-deep .el-menu {
		background: transparent;
		.el-menu-item {
			color: #ffffff;
			font-size: 16px;
			background: transparent;
		}
		.el-submenu__title {
			font-size: 16px;
			color: #fff;
			height: 40px;
			line-height: 40px;
		}
	}

	::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
		background: transparent;
		color: #1390ff;
	}
</style>
<style lang="scss">
	.el-menu--horizontal > .el-menu {
		background: rgba(0, 0, 0, 0.5);
		background: transparent;
		min-width: fit-content;
	}
	.el-menu--horizontal > .el-menu .el-menu-item {
		height: 40px;
		line-height: 40px;
		margin: 0 20px;
		background: rgba(0, 0, 0, 0.5);
		font-size: 16px;
		text-align: center;
		margin: 0px 10px;
	}
	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
		color: #1390ff !important;
	}
	.btnBox {
		width: 40px;
		height: 40px;
		border-radius: 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		position: relative;
		overflow: hidden;
		div {
			width: 80%;
			height: 3px !important;
			border-radius: 15px;
			background-color: #fff;
			position: absolute;
			transition-duration: 500ms;
			&:nth-child(1) {
				transform: translateY(-8px);
				width: 60%;
			}
			&:nth-child(3) {
				transform: translateY(8px);
				width: 40%;
			}
		}
	}
	.btnBoxhover {
		div {
			width: 80% !important;
			&:nth-child(2) {
				transform: translateX(40px);
			}
			&:nth-child(1) {
				transform: translateX(0px) rotate(135deg);
			}
			&:nth-child(3) {
				transform: translateX(0px) rotate(-135deg);
			}
		}
	}
</style>
